import { ListEnum as i } from "../extensions/list-extension/list-enum.mjs";
import { TextAlignEnum as t } from "../extensions/text-align-extension/text-align-enum.mjs";
import { TextFormatEnum as o } from "../extensions/text-format-extension/text-format-enum.mjs";
import { TextLevelEnum as e } from "../extensions/heading-extension/text-level-enum.mjs";
import { getOS as l } from "./get-os.mjs";
const c = {
  [o.Bold]: {
    toggle: "Mod-B"
  },
  [o.Italic]: {
    toggle: "Mod-I"
  },
  [o.Strike]: {
    toggle: "Mod-Shift-S"
  },
  [o.Underline]: {
    toggle: "Mod-U"
  },
  textAlign: {
    [t.Left]: "Mod-Shift-L",
    [t.Center]: "Mod-Shift-E",
    [t.Right]: "Mod-Shift-R",
    [t.Justify]: "Mod-Shift-J"
  },
  list: {
    [i.OrderedList]: "Mod-Shift-7",
    [i.BulletList]: "Mod-Shift-8"
  },
  heading: {
    [e.Default]: "Mod-Alt-0",
    [e.H2]: "Mod-Alt-2",
    [e.H3]: "Mod-Alt-3",
    [e.H4]: "Mod-Alt-4"
  },
  history: {
    undo: "Mod-Z",
    redo: "Shift-Mod-Z"
  }
}, g = (d) => {
  const r = l();
  return d.replace("Mod", r === "macOS" ? "⌘" : "Ctrl").replace("Alt", r === "macOS" ? "⌥" : "Alt").replace("-", " ");
};
export {
  g as getShortcut,
  c as rawShortcuts
};
